<template>
    <div>
        
        <v-row v-for="(question, index) in questions" :key="index">
            <v-col>
                <span class="evaluation-form-question-title">
                    {{question.question}} <span class="red--text">*</span>
                </span>
                <div @click="selectOption(question.options, opt, index, index2)" :class="`evaluation-form-question-item mb-2 ${opt.selected ? 'evaluation-form-question-item-selected' : ''}`" v-for="(opt, index2) in question.options" :key="index2">
                    <span>
                        ({{opt.value}}) {{opt.option}}
                    </span>
                </div>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <textAreaForm
                    label="¿Tienes algún comentario u opinión extra que consideres necesario agregar? (En caso de que alguna de las calificaciones sean igual o menor a 3, agrega comentarios de mejora)"
                    :valueInput="values.comments"
                    :rule="[]"
                    @valueChange="(v) => {values.comments = v}"
                    :errorMessages="serverErrors[`comments`]"
                    :rows="1"
                ></textAreaForm>
            </v-col>
        </v-row>

        <v-row>
            <v-col>
                <div class="evaluation-form-summary-container mt-1">
                    <span>
                        Promedio general del evaluado
                    </span>
                    <span>
                        {{finalResult}}
                    </span>
                </div>
            </v-col>
        </v-row>

        


        
    </div>
</template>

<script>

/* eslint-disable */
export default {
    props: ['values', 'questions', 'serverErrors', 'edit'],
   
    data(){
        return {
            finalResult:this.getFinalResult(this.values.answers),

            rules: {
                required: [
					v => {
                        if(v == null || v == undefined)
                            return "Campo requerido";
                        try {
                            if(v.trim() == "")
                                return "Campo requerido";
                        } catch (error) {
                            console.log(error);
                        }
                        return true;
                    }
				],
                
				
            },
            
          
        }
    },
    watch: {
        values: function (vv) {
            //console.log(this.values, vv);
        }
    },
    mounted(){
    },
    methods: {
        selectOption(allOptions, option, questionIndex, optionIndex){

            for (let i = 0; i < allOptions.length; i++) {
                allOptions[i].selected = false;
            }
            option.selected = true;

            let found = this.values.answers.find((x) => x.question_id == this.questions[questionIndex].id);
            found.answer = option.value;
            this.finalResult = this.getFinalResult(this.values.answers);
        },
        getFinalResult(answers)
        {
            let sum = 0;
            answers.forEach(item => {
                sum = sum + parseInt(item.answer == '' ? 0 : item.answer)??0;
            });

            sum = (sum / 6).toFixed(1);

            let text = '';
            if(sum < 2)
                text = "Mínimo";
            else if(sum < 4)
                text = "Medio";
            else
                text = "Alto";

            return `${sum} (${text})`
        },
      
    }
}
</script>

<style lang="scss">
    .evaluation-form{
        &-question-title{
            font-size: 0.8rem;
            font-weight: 500;
            line-height: 1rem !important;
        }

        &-summary-container{
            display: flex;
            justify-content: space-between;
            border: 0.17rem solid #E572AA;
            padding: 0px 1.4rem 0px 1.4rem;
            color: #E572AA;
            font-weight: 600;
        }

        &-question-item{
            padding: 0.2rem 2rem 0.2rem 1.5rem;
            border: solid 1px transparent;
            border-radius: 8px;
            background-color: #F7F7F7;
            font-size: .8rem;
            cursor: pointer;
            transition: border 0.3s ease-in-out;

            &:hover{
                border: solid 1px #E572AA;
            }
        }

        &-question-item-selected{
            border: solid 1px #E572AA;
        }

        
    }
</style>